import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import { isMaintenanceMode } from './utils/maintenanceMode';
import { ServiceUnavailablePage } from './pages/service-unavailable';

const root = ReactDOM.createRoot(document.getElementById('root')!);

// In maintenance mode the normal app (MSAL, App Insights, API providers) is never loaded.
if (isMaintenanceMode()) {
  root.render(
    <React.StrictMode>
      <ServiceUnavailablePage />
    </React.StrictMode>,
  );
} else {
  import('./bootstrapApp').then(({ renderApp }) => renderApp(root));
}
